import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

// cssリセット
import './assets/css/reset.css'

// UUIDライブラリ
import VueUUID from 'vue-uuid'
// @ts-expect-error Vue2.7の型厳密化によってライブラリ読み込み時にエラーが発生するため、コメントで除外
Vue.use(VueUUID)

// UUID取得処理のラッパーライブラリ
import UUIDWrapper from './plugins/UUIDWrapper'
Vue.use(UUIDWrapper)

// 通信関連の設定
import http from './plugins/http'
Vue.use(http, router)

// モーダル表示ライブラリ
import VModal from 'vue-js-modal'
Vue.use(VModal)

// カレンダー系ライブラリ
import VCalendar from 'v-calendar'
Vue.use(VCalendar)

// ローディング中のオーバーレイ
import Loading from './plugins/Loading'
Vue.use(Loading)

// コンソール出力ラッパー
import Console from './plugins/Console'
Vue.use(Console)

// クッキー関連
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import AppCookies from './plugins/AppCookies'
Vue.use(AppCookies)

// 画面遷移時の元画面情報
import PrevPage from './plugins/PrevPage'
Vue.use(PrevPage)

// アプリケーション例外処理
import AppErrors from './plugins/AppErrors'
Vue.use(AppErrors)

// ツールチップライブラリ
import FloatingVue from 'floating-vue'
Vue.use(FloatingVue)

/* eslint-disable @typescript-eslint/explicit-function-return-type */
new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
